exports.init = function PaymentFormSelector() {
  const $checkReembolsavelDespesa         = $('#reembolsavelDespesa');
  const $checkReembolsavelPercurso        = $('#reembolsavelPercurso');
  const $checkReembolsavelPercursoMapa    = $('#reembolsavelPercursoMapa');
  const idPagamentoFormaDespesa           = document.getElementById('idPagamentoFormaDespesa');
  const $idPagamentoFormaPercurso         = $('#idPagamentoFormaPercurso');
  const $idPagamentoFormaPercursoMapa     = $('#idPagamentoFormaPercursoMapa');
  const objectFormasPagamentoPercurso     = $idPagamentoFormaPercurso.data('pagamentoFormas');
  const objectFormasPagamentoPercursoMapa = $idPagamentoFormaPercursoMapa.data('pagamentoFormas');
  const objectFormasPagamentoDespesa      = idPagamentoFormaDespesa
    ? JSON.parse(idPagamentoFormaDespesa.dataset.pagamentoFormas)
    : null;

  if (idPagamentoFormaDespesa !== null && idPagamentoFormaDespesa.length) {
    if (idPagamentoFormaDespesa[0].value === '') {
      $checkReembolsavelDespesa.attr('disabled', false);
    } else {
      $checkReembolsavelDespesa.attr('disabled', true);
    }

    idPagamentoFormaDespesa.addEventListener('change', function (e) {
      e.preventDefault;
      if(this.value === ''){
        $checkReembolsavelDespesa.attr('disabled', false);
      } else {
        if (objectFormasPagamentoDespesa[this.value]) {
          $checkReembolsavelDespesa.attr('checked', true);
          $checkReembolsavelDespesa.attr('disabled', true);
          $checkReembolsavelDespesa.closest('label')[0].classList.add('active');
        } else {
          $checkReembolsavelDespesa.attr('checked', false);
          $checkReembolsavelDespesa.attr('disabled', true);
          $checkReembolsavelDespesa.closest('label')[0].classList.remove('active');
        }
      }
    });
  }

  if ($idPagamentoFormaPercurso.length) {
    if ($idPagamentoFormaPercurso[0].value === '') {
      $checkReembolsavelPercurso.attr('disabled', false);
    } else {
      $checkReembolsavelPercurso.attr('disabled', true);
    }
    $idPagamentoFormaPercurso.selectize({
      create: false,
      maxItems: 1,
      selectOnTab: true,
      hideSelected: true,
      onChange: function(value) {
        if (value === '') {
          $checkReembolsavelPercurso.attr('disabled', false);
        } else {
          if (objectFormasPagamentoPercurso[value]) {
            $checkReembolsavelPercurso.prop('checked', true);
            $checkReembolsavelPercurso.attr('disabled', true);
            $checkReembolsavelPercurso.closest('label')[0].classList.add('active');
          } else {
            $checkReembolsavelPercurso.prop('checked', false);
            $checkReembolsavelPercurso.attr('disabled', true);
            $checkReembolsavelPercurso.closest('label')[0].classList.remove('active');
          }
        }
      }
    });
  }

  if ($idPagamentoFormaPercursoMapa.length) {
    if ($idPagamentoFormaPercursoMapa[0].value === '') {
      $checkReembolsavelPercursoMapa.attr('disabled', false);
    } else {
      $checkReembolsavelPercursoMapa.attr('disabled', true);
    }
    $idPagamentoFormaPercursoMapa.selectize({
      create: false,
      maxItems: 1,
      selectOnTab: true,
      hideSelected: true,
      onChange: function(value) {
        if (value === '') {
          $checkReembolsavelPercursoMapa.attr('disabled', false);
        } else {
          if (objectFormasPagamentoPercursoMapa[value]) {
            $checkReembolsavelPercursoMapa.prop('checked', true);
            $checkReembolsavelPercursoMapa.attr('disabled', true);
            $checkReembolsavelPercursoMapa.closest('label')[0].classList.add('active');
          } else {
            $checkReembolsavelPercursoMapa.prop('checked', false);
            $checkReembolsavelPercursoMapa.attr('disabled', true);
            $checkReembolsavelPercursoMapa.closest('label')[0].classList.remove('active');
          }
        }
      }
    });
  }
}
